<svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" fill="currentColor" viewBox="0 0 18 18">
  <g clip-path="url(#a)">
    <path d="M15.75 7.65H9.675C9.099 5.832 7.416 4.5 5.4 4.5A4.502 4.502 0 0 0 .9 9c0 2.484 2.016 4.5 4.5 4.5 2.016 0 3.699-1.332 4.275-3.15h.675l1.35 1.35 1.35-1.35 1.35 1.35L17.1 9l-1.35-1.35ZM5.4 11.25a2.25 2.25 0 1 1 .002-4.502A2.25 2.25 0 0 1 5.4 11.25Z"/>
  </g>
  <defs>
    <clipPath id="a">
      <path d="M0 0h18v18H0z"/>
    </clipPath>
  </defs>
</svg>
